import { GET_FAQS } from "./types";
import firebase from "firebase";
import axios from "axios";

export const getFaqs = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("faqs")
    .onSnapshot((snap) => {
      var faqs = [];
      snap.docs.forEach((doc) => {
        faqs.push({ id: doc.id, ...doc.data() });
      });
      dispatch({ type: GET_FAQS, faqs });
    });
};
